import bigSlider from './../components/home-page/big-slider';
import experienceSlider from './../components/home-page/experience-slider';
import selectBox from './../components/home-page/select-box';

export default () => {
  bigSlider();
  experienceSlider();
  //selectBox();

  // const enquiryFormOverlay = document.querySelector('.enquiry_form_overlay');
  // const floaterWrap = document.querySelector('.floater-wrap')
  // const handleFloaterWrapClick = () => {
  //   const isEnquiryFormOverlayVisible = window.getComputedStyle(enquiryFormOverlay).display === 'block';

  //   if (isEnquiryFormOverlayVisible) {
  //     const enquiryFormOverlayHeight = enquiryFormOverlay.clientHeight;
  //     const enquiryFormOverlayScrollHeight = enquiryFormOverlay.scrollHeight;

  //     enquiryFormOverlay.style.top = `${enquiryFormOverlayHeight - enquiryFormOverlayScrollHeight}px`;

  //     // console.log('enquiryFormOverlayHeight:', enquiryFormOverlayHeight);
  //     // console.log('enquiryFormOverlayScrollHeight:', enquiryFormOverlayScrollHeight);
  //     // console.log(`${enquiryFormOverlayHeight - enquiryFormOverlayScrollHeight}px`);
  //   }
  // };

  // floaterWrap.addEventListener('click', handleFloaterWrapClick);
};